module.exports = __webpack_public_path__ + "img/detail-back2.226c6e17.svg";